// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name-file[data-v-fdd5f67c] {\n  word-break: break-all;\n}\n.sticky-column[data-v-fdd5f67c] {\n  position: sticky;\n  top: 10px;\n  max-height: 95vh;\n  overflow-y: auto;\n}\n.disabled-option[data-v-fdd5f67c] {\n  cursor: not-allowed;\n  color: #808080;\n}", ""]);
// Exports
module.exports = exports;
